import React from 'react';

const Benefits = () => {
  const benefits = [
    {
      icon: '💰',
      title: 'Increase Repeat Sales',
      description: 'Stay connected with customers via WhatsApp. Send offers, updates & reminders to drive repeat purchases.'
    },
    {
      icon: '📊',
      title: 'Build Customer Database',
      description: 'Collect customer WhatsApp numbers effortlessly. No manual entry, no forms - just scan and connect.'
    },
    {
      icon: '⚡',
      title: 'Instant Connection',
      description: 'Customers scan your QR code and WhatsApp opens instantly. No app downloads or complicated steps.'
    },
    {
      icon: '🎯',
      title: 'Higher Engagement',
      description: 'WhatsApp has 98% open rate. Your messages get seen and read, unlike emails that go to spam.'
    },
    {
      icon: '💎',
      title: 'Premium Quality',
      description: 'Elegant acrylic stand and professional stickers that enhance your business image.'
    },
    {
      icon: '🚀',
      title: 'Easy Setup',
      description: 'Set up in 30 seconds. No technical knowledge needed. Works with your existing WhatsApp number.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Your Business Needs This
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stop losing customers after they leave your store. Turn every walk-in into a lifetime connection.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6 hover:shadow-lg transition-shadow">
              <div className="text-4xl mb-4">{benefit.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">🚨 The Problem Most Businesses Face</h3>
          <div className="grid md:grid-cols-3 gap-6 mt-8">
            <div>
              <p className="text-3xl font-bold mb-2">80%</p>
              <p className="text-green-100">of customers never return after first visit</p>
            </div>
            <div>
              <p className="text-3xl font-bold mb-2">Zero</p>
              <p className="text-green-100">contact details captured from walk-ins</p>
            </div>
            <div>
              <p className="text-3xl font-bold mb-2">Lost</p>
              <p className="text-green-100">opportunities to send offers & updates</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;